import React, { useState } from 'react'

import { 
    DisclaimerContainerDiv,
    DisclaimerContainerContentsDiv,
    DisclaimerContentsDiv,
    DisclaimerHeaderContainer,
    DisclaimerSectionHeader,
    DisclaimerDescription,
    CollapseButton,
    ExpandButton 
} from '../../Styles/Components/DisclaimerStyles'

function Disclaimer(props){
    const [hide,setHide] = useState(false)

    function toggleHide(){
        setHide(!hide)
    }

    return (
        <DisclaimerContainerDiv id="blurb-section">
            <DisclaimerContainerContentsDiv>
                <DisclaimerContentsDiv>
                    <DisclaimerHeaderContainer>
                        <DisclaimerSectionHeader>Disclaimer</DisclaimerSectionHeader>
                        {hide ? <ExpandButton onClick={toggleHide} /> : <CollapseButton onClick={toggleHide} />}
                    </DisclaimerHeaderContainer>
                    {!hide && <DisclaimerDescription>Although functional, this website and the linked extension that can be downloaded is only for portfolio purposes. It is currently not maintained. If you would like to obtain ownership of the code or maintain it, please contact me! No subscription is necessary to use this service.</DisclaimerDescription>}
                </DisclaimerContentsDiv>
            </DisclaimerContainerContentsDiv>
        </DisclaimerContainerDiv>
    )
}

export default Disclaimer